module.exports = __webpack_public_path__ + "img/1_0.f32002c3.png";